<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template>

        <t-input v-model="form.typeEnterpriseId" hidden/>

        <t-input v-model="form.name" :add-error="error.name" label="Tipo de Empreendimento" required/>

        <t-input v-model="form.note" max-length="2000" rows="7" textarea label="Observações" required/>


        <t-input v-model="form.integrationNote" max-length="255" rows="7"
                 help="Utilizado em customizações especiais de laudos avançados" label="Integração Especial"/>


        <!--        <t-editor label="Observações" max-length="2000" v-model="form.note"></t-editor>-->

        <t-input-status v-model="form.status"/>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
/*import TEditor from "@/components/template/page/t-editor.vue";*/

export default {
  /*  components: {TEditor},*/
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'TypeEnterpriseForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "typeEnterpriseId",
      form: {
        typeEnterpriseId: 0,
        typeEnterpriseNumber: 0,
        name: "",
        note: "",
        integrationNote: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

